import { airportIanaZone } from '@/lib/disruptions/airport-tz';

// PO 2026-10-28: when the airline has no flight for a PNR, Nexa searches other airlines
// (Duffel / Atlas) by itself and shows the offers as a proposal a supervisor approves.

/** `YYYY-MM-DD` of `at` on the airport's own calendar. Pure. */
function airportDay(at: Date, iata: string): string {
  return new Intl.DateTimeFormat('en-CA', {
    timeZone: airportIanaZone(iata),
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(at);
}

/**
 * The date the automatic other-airline search asks for: the disrupted departure's day at the
 * origin airport, never before today there (a past day would quote flights already gone). Pure.
 */
export function autoSearchDate(departureIso: string | undefined, origin: string, now: Date = new Date()): string {
  const today = airportDay(now, origin);
  const at = departureIso ? new Date(departureIso) : undefined;
  const day = at && Number.isFinite(at.getTime()) ? airportDay(at, origin) : today;
  return day > today ? day : today;
}
